import { setBreakpointVariables } from './breakpoints';

setBreakpointVariables();
